/**
 * @file skeletonColumns — responsive column count for skeleton grids.
 * @description Pure replacement for the prior
 * `useBreakpointValue({ default: 2, sm: 2, md: 3, lg: 4 })` call used by the
 * comparison / player-detail skeleton containers. Routing the column count
 * through a pure width helper (fed by `useWindowDimensions`) removes the
 * `@/components/ui/utils/use-break-point-value` import banned by the
 * design-system import-closure (docs/design-system-rfc.md §3/§5) while keeping
 * the resolved value identical. Breakpoints are the Tailwind/NativeWind
 * defaults the original hook resolved against (sm 640, md 768, lg 1024).
 * @module utils/skeletonColumns
 */

/** Tailwind/NativeWind default breakpoint widths (px). */
const MD_BREAKPOINT = 768;
const LG_BREAKPOINT = 1024;

/**
 * Resolve the skeleton-grid column count for a viewport width, matching the
 * prior `useBreakpointValue({ default: 2, sm: 2, md: 3, lg: 4 })` mapping.
 * @param width - Current viewport width in pixels.
 * @returns 4 at lg+, 3 at md, otherwise 2 (default / sm share the same value).
 */
export const skeletonColumnsForWidth = (width: number): number => {
  if (width >= LG_BREAKPOINT) return 4;
  if (width >= MD_BREAKPOINT) return 3;
  return 2;
};
